import angular from 'angular';
import uiRouter from 'angular-ui-router';
import analyticsComponent from './analytics-bot.component';

let analyticsModule = angular.module('app.containers.analytics-bot', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('analyticsBot', {
      url: '/analytics-bot',
      template: '<analytics-bot></analytics-bot>'
    });
})

.component('analyticsBot', analyticsComponent);

export default analyticsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-bot/analytics-bot.js
 **/